module.exports = __webpack_public_path__ + "static/media/twsLowFi.8b7a0a8f.png";